import { render } from "./HomePa.vue?vue&type=template&id=c7c2ecde&scoped=true"
import script from "./HomePa.vue?vue&type=script&lang=js"
export * from "./HomePa.vue?vue&type=script&lang=js"

import "./HomePa.vue?vue&type=style&index=0&id=c7c2ecde&scoped=true&lang=scss"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c2ecde"]])

export default __exports__